export const isLoggedInUserGuest = currentUser => {
  return currentUser?.attributes?.profile?.privateData?.guestAccount === true;
};

export const isGuestUser = currentUser => {
  const isGuest = Boolean(!currentUser?.id?.uuid || isLoggedInUserGuest(currentUser));
  return isGuest;
};
